import { render } from "./DimensionRadarChart.vue?vue&type=template&id=19e5c835&scoped=true"
import script from "./DimensionRadarChart.vue?vue&type=script&lang=js"
export * from "./DimensionRadarChart.vue?vue&type=script&lang=js"

import "./DimensionRadarChart.vue?vue&type=style&index=0&id=19e5c835&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e5c835"]])

export default __exports__